import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import appHistory from '../../utils/appHistory';
import { usePostAuthLandingGate, shouldDeferFirstTabRedirect } from '../login/postAuthLandingGate';
import getNavItems, { shouldUseHierarchicalNav, partitionCabinetsForNav } from './navItems';

/**
 * Shared post-auth / first-tab landing redirect for top and sidebar shells.
 * Mirrors FixedHeader (flat) and HierarchicalHeader (grouped) rules.
 */
const useLandingRedirect = ({
  user,
  cabinets: _cabinets = [],
  dashboards: _dashboards = [],
  settingsLoaded: _settingsLoaded = false
}) => {
  const {
    pathname
  } = useLocation();
  const landingGatePhase = usePostAuthLandingGate();
  useEffect(() => {
    var _items$;
    if (!_settingsLoaded || !user) {
      return;
    }
    if (shouldUseHierarchicalNav(_cabinets)) {
      const {
        groupedCabinets,
        ungroupedCabinets
      } = partitionCabinetsForNav({
        user,
        cabinets: _cabinets,
        dashboards: _dashboards
      });
      const hasLegacyFileCabinet = ungroupedCabinets.some(cabinet => cabinet.path === '/file-cabinet') || Object.values(groupedCabinets).some(group => group.some(cabinet => cabinet.path === '/file-cabinet'));
      const firstCabinet = [...ungroupedCabinets].sort((a, b) => a.sortOrder - b.sortOrder)[0];
      if (!firstCabinet) {
        return;
      }
      const firstVisibleTab = firstCabinet.directFormType ? `/directForms/new/${firstCabinet.directFormType}` : firstCabinet.path;
      const isLandingRoute = pathname === '/' || pathname === '/file-cabinet' && !hasLegacyFileCabinet;
      if (!isLandingRoute || shouldDeferFirstTabRedirect()) {
        return;
      }
      appHistory.replace(firstVisibleTab);
      return;
    }
    const items = getNavItems({
      user,
      cabinets: _cabinets,
      dashboards: _dashboards
    });
    const fileCabinetAvailable = items.some(item => item.key === 'reportsTab');
    const firstNavHref = (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.href;
    const shouldRedirect = !fileCabinetAvailable && Boolean(firstNavHref) && (pathname === '/' || pathname === '/logout');
    if (!shouldRedirect) {
      return;
    }
    appHistory.replace(firstNavHref.replace('/#', ''));
  }, [user, _cabinets, _dashboards, _settingsLoaded, pathname, landingGatePhase]);
};
export default useLandingRedirect;